import { esGoldPalettes } from "../../../../Posts/01-paletas/04-paleta-amarillo/01-dorado/goldPalettes.js";
import * as React from 'react';
export default {
  esGoldPalettes,
  React
};